/** What decides which actions on the whole account apply to it. */
export interface AccountActionsSubject {
  readonly managedByMasterAccount: boolean;
  /** The master account's own books live and die with the master account. */
  readonly isMasterAccountOwnBooks: boolean;
}

/** The subject of the profile's account; null while it is unknown. */
export function accountActionsSubjectOf(
  account:
    | {
        readonly managingMasterAccount?: unknown;
        readonly isMasterAccountOwnBooks?: boolean | null;
      }
    | null
    | undefined
): AccountActionsSubject | null {
  if (!account) return null;
  return {
    managedByMasterAccount: !!account.managingMasterAccount,
    isMasterAccountOwnBooks: !!account.isMasterAccountOwnBooks
  };
}

/** The actions Account management offers; the section is in the menu only when one applies. */
export interface AccountActions {
  readonly declareMasterAccount: boolean;
  readonly leaveMasterAccount: boolean;
  readonly deleteAccount: boolean;
}

export function accountActions(
  { managedByMasterAccount, isMasterAccountOwnBooks }: AccountActionsSubject,
  canManageAccountSettings: boolean
): AccountActions {
  return {
    declareMasterAccount: canManageAccountSettings && !managedByMasterAccount,
    leaveMasterAccount:
      canManageAccountSettings && managedByMasterAccount && !isMasterAccountOwnBooks,
    deleteAccount: !isMasterAccountOwnBooks
  };
}

export function hasAnyAccountAction(actions: AccountActions): boolean {
  return actions.declareMasterAccount || actions.leaveMasterAccount || actions.deleteAccount;
}
